import React from "react";

const SectionTitle = ({ subTitle, MainTitle }) => {
  return (
    <div className="row">
      <div className="wpo-section-title">
        <span>{subTitle}</span>
        <h2>{MainTitle}</h2>
      </div>
    </div>
  );
};

export default SectionTitle;
